import React, {Component} from 'react';
import {Chip, Grid, Typography, Tooltip} from 'material-ui';
import {connect} from 'react-redux';
import OpenWithIcon from 'material-ui-icons/OpenWith';
import ColorPicker from '../../../../components/colorPicker/color_picker';
import {fetchBgColors} from '../../thunks';

class SectionTitle extends Component {
    componentDidMount() {
        this.props.fetchBgColors();
    }

    render() {
        const {
            classes,
            sectionType,
            title,
            connectDragSource,
            hideDragIcon,
            changeSectionBgColor,
            colors,
            sectionBgColorId,
        } = this.props;

        return (
            <Grid container spacing={0} className={classes.pbSectionCaption}>
                <Grid item xs={6}>
                    <Grid
                        container
                        direction="row"
                        justify="flex-start"
                        spacing={0}
                    >
                        <Typography
                            variant="title"
                            gutterBottom
                            className={classes.pbSectionTitle}
                        >
                            {title ? title : ''}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                    <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        spacing={0}
                    >
                        <Grid>
                            <ColorPicker
                                classes={classes}
                                onChangeSectionBgColor={(
                                    sectionBgColorId,
                                    sectionId,
                                    pageId
                                ) =>
                                    changeSectionBgColor(
                                        sectionBgColorId,
                                        sectionId,
                                        pageId
                                    )
                                }
                                colors={colors}
                                sectionBgColorId={sectionBgColorId}
                            />
                        </Grid>
                        <Grid item className={classes.pbSectionCaptionChip}>
                            <Chip label={sectionType} />
                        </Grid>
                        <Grid item>
                            {!hideDragIcon &&
                                connectDragSource(
                                    <div className={classes.pbSectionDrag}>
                                        <Tooltip title="Click here in order to Drag &amp; Drop section">
                                            <OpenWithIcon />
                                        </Tooltip>
                                    </div>
                                )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state, props) => ({
    colors: state.pageBuilder.bgColors,
});

export default connect(
    mapStateToProps,
    {
        fetchBgColors,
    }
)(SectionTitle);



// WEBPACK FOOTER //
// ./src/containers/builder/sections/tab_dnd/section_title.js